import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { PrimaryContact } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class PrimaryContactEntityHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<PrimaryContact> {
    return this.httpApi.get(`/primary_contact`).pipe(map(res => res.primaryContact));
  }

  public update(data: Partial<PrimaryContact>, isCreate: boolean): Observable<PrimaryContact> {
    return (
      isCreate
        ? this.httpApi.post(`/primary_contact`, null, data)
        : this.httpApi.patch(`/primary_contact`, null, data)
    ).pipe(map(res => res.primaryContact));
  }
}
